const CupComponentView = cc.Node.extend({
    ctor: function (cup, unitView) {
        this._super();

        this.cup = cup;
        this.unitView = unitView;

        this.createProgress();
        this.restoreState();
    },

    restoreState: function (animated) {
        if (cleverapps.gameModes.hideGuideAndProgress || this.cup.isFull() || this.cup.isEmpty()) {
            this.hideProgress(animated);
        } else {
            this.showProgress(animated);
        }

        this.updateProgress(animated);
        if (animated && !cleverapps.gameModes.muteCupsSound) {
            cleverapps.effects.fire(`cup.${this.cup.unit.code}`);
        }
    },

    createProgress: function () {
        const styles = cleverapps.styles.CupComponentView;

        this.progress = new ScaledProgressBar({
            type: styles.progress.type
        });
        this.progress.hidden = false;
        this.unitView.addChild(this.progress);
        this.progress.setAlignment(styles.progress);
        this.progress.setLength(styles.progress.width);
        this.progress.setCascadeOpacityEnabled(true);
    },

    updateProgress: function (animated) {
        this.progress.setGoal(this.cup.unit.getData().cup.amount);
        this.progress.setPercentage(this.cup.amount, {
            animated
        });
    },

    showProgress: function (animated) {
        if (!this.progress.hidden) {
            return;
        }
        this.progress.hidden = false;
        this.progress.stopAllActions();

        if (!animated) {
            this.progress.setVisible(true);
            return;
        }

        this.progress.runAction(new cc.Sequence(
            new cc.MoveBy(0, 0, 15),
            new cc.ScaleTo(0, 0.5),
            new cc.Show(),
            new cc.Spawn(
                new cc.MoveBy(0.1, 0, -15),
                new cc.ScaleTo(0.1, 1)
            )
        ));
    },

    hideProgress: function (animated, callback) {
        callback = callback || function () {};

        if (this.progress.hidden) {
            callback();
            return;
        }
        this.progress.hidden = true;
        this.progress.stopAllActions();

        if (!animated) {
            this.progress.setVisible(false);
            callback();
            return;
        }

        this.progress.setVisible(true);
        this.progress.runAction(new cc.Sequence(
            new cc.Spawn(
                new cc.FadeOut(0.1),
                new cc.ScaleTo(0.1, 0.7)
            ),
            new cc.Hide(),
            new cc.CallFunc(callback)
        ));
    },

    playDestruction: function () {
        if (this.progress) {
            const movingNode = cleverapps.Scenes.GetMovingNode(this.progress);
            this.progress.replaceParentSamePlace(movingNode);
            this.progress.setLocalZOrder(2);

            this.hideProgress(true, () => {
                this.progress.removeFromParent();
            });
        }
    }
});

cleverapps.styles.CupComponentView = {
    progress: {
        width: 84,
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -50 },
        type: ScaledProgressBar.Types.blue_small_with_frames
    }
};
